import { motion } from "framer-motion";
import { useT } from "../i18n/LanguageContext";

export default function DualCTA({ onBookTour, onVR }) {
    const { t } = useT();
    return (
        <section
            className="relative py-20 md:py-28 bg-charcoal-surface"
            data-testid="dual-cta-section"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 gap-5">
                <motion.button
                    onClick={onBookTour}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="group relative overflow-hidden text-left p-10 md:p-14 border border-white/10 bg-charcoal hover:border-gold transition-all duration-500"
                    data-testid="dual-cta-visit"
                >
                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700">
                        <img
                            src="https://customer-assets.emergentagent.com/job_wynwood-short-term/artifacts/5dbsffd3_Imagen%2021-4-26%20a%20las%2021.21%20%282%29.jpeg"
                            alt=""
                            className="w-full h-full object-cover opacity-40"
                        />
                        <div className="absolute inset-0 bg-charcoal/80" />
                    </div>
                    <div className="relative z-10">
                        <div className="text-[11px] tracking-[0.4em] uppercase text-gold font-semibold">
                            {t("dcta.opt_a_label")}
                        </div>
                        <h3 className="mt-5 font-display text-3xl md:text-4xl font-semibold tracking-tight leading-tight">
                            {t("dcta.opt_a_heading")}
                        </h3>
                        <p className="mt-4 text-white/60 max-w-md">
                            {t("dcta.opt_a_body")}
                        </p>
                        <div className="mt-8 inline-flex items-center gap-3 text-[11px] tracking-[0.25em] uppercase text-gold group-hover:gap-5 transition-all">
                            {t("dcta.opt_a_cta")}
                            <span className="w-10 h-[1px] bg-gold" />
                        </div>
                    </div>
                </motion.button>

                <motion.button
                    onClick={onVR}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.1 }}
                    className="group relative overflow-hidden text-left p-10 md:p-14 border border-white/10 bg-charcoal hover:border-gold transition-all duration-500"
                    data-testid="dual-cta-vr"
                >
                    <div className="absolute inset-0 opacity-40 group-hover:opacity-70 transition-opacity duration-700">
                        <img
                            src="https://images.unsplash.com/photo-1714647212110-99aefedfd372"
                            alt=""
                            className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-charcoal/80" />
                    </div>
                    <div className="relative z-10">
                        <div className="text-[11px] tracking-[0.4em] uppercase text-gold font-semibold">
                            {t("dcta.opt_b_label")}
                        </div>
                        <h3 className="mt-5 font-display text-3xl md:text-4xl font-semibold tracking-tight leading-tight">
                            {t("dcta.opt_b_heading")}
                        </h3>
                        <p className="mt-4 text-white/60 max-w-md">
                            {t("dcta.opt_b_body")}
                        </p>
                        <div className="mt-8 inline-flex items-center gap-3 text-[11px] tracking-[0.25em] uppercase text-gold group-hover:gap-5 transition-all">
                            {t("dcta.opt_b_cta")}
                            <span className="w-10 h-[1px] bg-gold" />
                        </div>
                    </div>
                </motion.button>
            </div>
        </section>
    );
}
